import { Component, ElementRef, OnInit, ViewChild, HostListener, TemplateRef, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../../services/common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-download-disclaimer',
  templateUrl: './download-disclaimer.component.html',
  styleUrls: ['./download-disclaimer.component.scss']
})
export class DownloadDisclaimerComponent implements OnInit {
  [x: string]: any;
  @ViewChild('download', { static: false }) download: ElementRef;
  viewingIMG: any;
  @Input() registrationData: any;
  constructor(
    private router: Router,
    public common: CommonService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }
  convertToPdf() {
    const element = this.download.nativeElement;
    var opt = {
      margin: 0.3,
      filename: 'Disclaimer.pdf',  // You can specify the filename
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' }
    };
    
    if (element) {
      html2pdf()
        .from(element)
        .set(opt)
        .save();
    } else {
      console.error('Element not found');
    }
  }
  
  disclaimerClose() {
    this.modalService.dismissAll();
  }
  Close() {
    this.imageModel.close();
  }
  ViewImage(content, img) {
    this.viewingIMG = img;
    this.imageModel = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', windowClass: 'view_event_img_popup' });
  }
}